<template>
  <div class="contact">
    <div class="container py-5">
      <div class="row">
        <div class="col-md-8 mx-auto text-center">
          <h1 class="mb-4">{{ t('contact.title') }}</h1>
          <p class="lead mb-5">{{ t('contact.subtitle') }}</p>

          <div class="card p-4 shadow-sm">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from '@/components/common/ContactForm.vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'ContactView',
  components: {
    ContactForm
  },
  setup() {
    const {t, locale} = useI18n();
    return {t, locale};
  },
  created() {
    this.setPageTitle(this.t('contact.title'));
  }
}
</script>